(() => {
  const root = document.documentElement;
  if (!root.classList.contains('shamma-scroll')) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.remove('shamma-scroll');
    return;
  }

  const pending = new Set();

  const isHero = (section) =>
    !!(
      section.querySelector('.shamma-story-hero') ||
      section.querySelector('[class*="ai-slideshow"]')
    );

  const show = (el) => {
    if (!el || el.classList.contains('is-visible')) return;
    el.classList.add('is-visible');
    pending.delete(el);
  };

  const isInView = (el) => {
    const rect = el.getBoundingClientRect();
    if (rect.height < 2 && rect.width < 2) return true;
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const visible = Math.min(rect.bottom, vh * 0.92) - Math.max(rect.top, 0);
    return visible > Math.min(80, rect.height * 0.12);
  };

  const flush = () => {
    pending.forEach((el) => {
      if (isInView(el)) show(el);
    });
  };

  const watch = (section) => {
    if (!(section instanceof Element)) return;
    if (isHero(section) || section.classList.contains('is-visible')) {
      show(section);
      return;
    }
    pending.add(section);
    if (isInView(section)) show(section);
  };

  const scan = () => {
    const parent = document.getElementById('MainContent');
    if (!parent) return;
    parent.querySelectorAll(':scope > .shopify-section').forEach(watch);
    flush();
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      flush();
    });
  };

  const start = () => {
    scan();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.setTimeout(flush, 80);
    window.setTimeout(flush, 400);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.matches && event.target.matches('.shopify-section')) {
      watch(event.target);
    }
  });
})();
